import { RouteConfig } from 'vue-router';
const PAGE_TITLE = '2021健康中国行动 ”终结结核病 点亮城市的红 ”';
const baseUrl = '20210315JKZG';
const route: RouteConfig = {
  path: `/${baseUrl}`,
  name: baseUrl,
  component: () => import('./ViewHolder.vue'),
  redirect: `/${baseUrl}/welcome`,
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'welcome',
      name: `${baseUrl}-welcome`,
      component: () => import('./pages/Welcome.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },

    {
      path: 'news',
      name: `${baseUrl}-news`,
      component: () => import('./pages/NewsList.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'rank',
      name: `${baseUrl}-rank`,
      component: () => import('./pages/Rank.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'list',
      name: `${baseUrl}-list`,
      component: () => import('./pages/List.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'detail',
      name: `${baseUrl}-detail`,
      component: () => import('./pages/Detail.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'related-news',
      name: `${baseUrl}-related-news`,
      component: () => import('./pages/RelatedNews.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'light-show',
      name: `${baseUrl}-light-show`,
      component: () => import('./pages/LightShow.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
  ],
};

export default route;
